// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.alert_alert__j28n {
    width: 100%;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    justify-content: flex-start;
    border-radius: 0.5rem;
    padding-top: .875rem;
    padding-bottom: .875rem;
    padding-left: 1rem;
    padding-right: 1rem;
    margin-bottom: 7px;
    min-height: 1.5rem;
    pointer-events: all;
}

.alert_alert__j28n.alert_warn_FtwNM {
    background: #FFF0DF;
    border: 1px solid #FF8C1A;
    box-shadow: 0px 0px 0px 2px rgba(255, 140, 26, 0.25);
}

.alert_alert__j28n.alert_success_Sge7c {
    background: var(--extensions-light);
    border: 1px solid var(--extensions-tertiary);
    box-shadow: 0px 0px 0px 2px var(--extensions-light);
}

.alert_alert-spinner_rVLcM {
    self-align: center;
}

.alert_icon-section_LzpeB {
    min-width: 1.25rem;
    min-height: 1.25rem;
    display: flex;
    padding-right: 1rem;
}

.alert_alert-icon_ST2yA {
    vertical-align: middle;
}

.alert_alert-message_LxLsV {
    color: #555;
    font-weight: bold;
    font-size: .8125rem;
    line-height: .875rem;
    display: flex;
    align-items: center;
    padding-right: .5rem;
}

.alert_alert-buttons_lAitv {
    display: flex;
    flex-direction: row;
}

.alert_alert-close-button_Jsfcc {
    outline-style:none;
}

.alert_alert-close-button-container_U59TG {
    outline-style: none;
    width: 30px;
    height: 30px;
    align-self: center;
}

.alert_alert-connection-button_Gr7kv {
    min-height: 2rem;
    width: 6.5rem;
    padding: 0.55rem 0.9rem;
    border-radius: 0.35rem;
    background: #FF8C1A;
    color: white;
    font-weight: 700;
    font-size: 0.77rem;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    outline-style:none;
}

[dir="ltr"] .alert_alert-connection-button_Gr7kv {
    margin-right: 13px;
}

[dir="rtl"] .alert_alert-connection-button_Gr7kv {
    margin-left: 13px;
}

/* prevent last button in list from too much margin to edge of alert */

.alert_alert-buttons_lAitv > :last-child {
    margin-left: 0;
    margin-right: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/alerts/alert.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;IAC3B,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,oDAAoD;AACxD;;AAEA;IACI,mCAAmC;IACnC,4CAA4C;IAC5C,mDAAmD;AACvD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,sEAAsE;;AAEtE;IACI,cAAc;IACd,eAAe;AACnB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.alert {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    overflow: hidden;\n    justify-content: flex-start;\n    border-radius: 0.5rem;\n    padding-top: .875rem;\n    padding-bottom: .875rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    margin-bottom: 7px;\n    min-height: 1.5rem;\n    pointer-events: all;\n}\n\n.alert.warn {\n    background: #FFF0DF;\n    border: 1px solid #FF8C1A;\n    box-shadow: 0px 0px 0px 2px rgba(255, 140, 26, 0.25);\n}\n\n.alert.success {\n    background: var(--extensions-light);\n    border: 1px solid var(--extensions-tertiary);\n    box-shadow: 0px 0px 0px 2px var(--extensions-light);\n}\n\n.alert-spinner {\n    self-align: center;\n}\n\n.icon-section {\n    min-width: 1.25rem;\n    min-height: 1.25rem;\n    display: flex;\n    padding-right: 1rem;\n}\n\n.alert-icon {\n    vertical-align: middle;\n}\n\n.alert-message {\n    color: #555;\n    font-weight: bold;\n    font-size: .8125rem;\n    line-height: .875rem;\n    display: flex;\n    align-items: center;\n    padding-right: .5rem;\n}\n\n.alert-buttons {\n    display: flex;\n    flex-direction: row;\n}\n\n.alert-close-button {\n    outline-style:none;\n}\n\n.alert-close-button-container {\n    outline-style: none;\n    width: 30px;\n    height: 30px;\n    align-self: center;\n}\n\n.alert-connection-button {\n    min-height: 2rem;\n    width: 6.5rem;\n    padding: 0.55rem 0.9rem;\n    border-radius: 0.35rem;\n    background: #FF8C1A;\n    color: white;\n    font-weight: 700;\n    font-size: 0.77rem;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    align-self: stretch;\n    outline-style:none;\n}\n\n[dir=\"ltr\"] .alert-connection-button {\n    margin-right: 13px;\n}\n\n[dir=\"rtl\"] .alert-connection-button {\n    margin-left: 13px;\n}\n\n/* prevent last button in list from too much margin to edge of alert */\n\n.alert-buttons > :last-child {\n    margin-left: 0;\n    margin-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `alert_alert__j28n`,
	"warn": `alert_warn_FtwNM`,
	"success": `alert_success_Sge7c`,
	"alert-spinner": `alert_alert-spinner_rVLcM`,
	"alertSpinner": `alert_alert-spinner_rVLcM`,
	"icon-section": `alert_icon-section_LzpeB`,
	"iconSection": `alert_icon-section_LzpeB`,
	"alert-icon": `alert_alert-icon_ST2yA`,
	"alertIcon": `alert_alert-icon_ST2yA`,
	"alert-message": `alert_alert-message_LxLsV`,
	"alertMessage": `alert_alert-message_LxLsV`,
	"alert-buttons": `alert_alert-buttons_lAitv`,
	"alertButtons": `alert_alert-buttons_lAitv`,
	"alert-close-button": `alert_alert-close-button_Jsfcc`,
	"alertCloseButton": `alert_alert-close-button_Jsfcc`,
	"alert-close-button-container": `alert_alert-close-button-container_U59TG`,
	"alertCloseButtonContainer": `alert_alert-close-button-container_U59TG`,
	"alert-connection-button": `alert_alert-connection-button_Gr7kv`,
	"alertConnectionButton": `alert_alert-connection-button_Gr7kv`
};
export default ___CSS_LOADER_EXPORT___;
